import React from 'react'

import styles from './ProductItemSkeleton.module.scss'

const ProductItemSkeleton = () => (
  <article className={styles.skeleton}>
    <div className={styles.head}>
      <div className={styles.icon} />
      <div className={styles.mainInfo}>
        <div className={styles.title} />
        <div className={styles.label} />
      </div>
      <div className={styles.checkbox} />
    </div>

    <div className={styles.description}>
      <div className={styles.line} />
      <div className={styles.line} />
      <div className={styles.lineShort} />
    </div>
  </article>
)

export default ProductItemSkeleton
